(function($, undefined) {
	'use strict';
	var utils;

	var displayAuthor = function() {
		var btn = $(this);
		var id = btn.attr('data-id');
		var ctn = btn.closest('.com-authors__tab-content');
		var currAuthor = ctn.find('.author.active');

		if (id !== currAuthor.attr('data-id')) {
			ctn.find('.com-authors__tab-content-author-btn').removeClass('active');
			currAuthor.fadeOut(function() {
				$(this).removeClass('active');

				btn.addClass('active');
				ctn.find('.author[data-id=' + id + ']').fadeIn(function() {
					$(this).addClass('active');
				});
			});
		}
	};

	var fetchBooks = function() {
		var showMax = 3;

		$('.author.js-fetch-books').each(function() {
			var t = $(this);

			$.ajax({
				url: '/action/ajaxGetProduct',
				cache: false,
				data: {
					genDataId: t.attr('data-id'),
					columnName: 'add_text_field1'
				},
				success: function (response) {
					if (response.length > 0) {
						for (var book in response) {
							var clone = t.find('.author__book.clone').clone().removeClass('clone');
							var img = clone.find('.author__book-img');
							
							clone.attr('href', clone.attr('href') + '/' + response[book].friendlyUrl);
							img.attr('src', img.attr('data-prefix') + response[book].mediaId + img.attr('data-suffix'));
							img.attr('alt', utils.decodeText(response[book].name));
							clone.find('.author__book-name').html(utils.decodeText(response[book].name));

							if ((parseInt(book) + 1) > showMax) {
								clone.addClass('hide element-to-toggle');
							}

							t.find('.author__books-ctn').append(clone);
						}
						
						t.find('.author__books-outer-ctn').removeClass('processing');
						if (response.length > showMax) {
							t.find('.author__books-toggle-btn-ctn').fadeIn();
						}

						var authorCopy = $('.author.copy-fetch[data-id="' + t.attr('data-id') +'"]');

						if (authorCopy.length > 0) {
							var childrenCtnClone = t.find('.author__books-ctn').clone();
							authorCopy.find('.author__books-ctn').append(childrenCtnClone.children());
							authorCopy.find('.author__books-outer-ctn').removeClass('processing');

							if (response.length > showMax) {
								authorCopy.find('.author__books-toggle-btn-ctn').fadeIn();
							}
						}
					} else {
						t.find('.author__books-outer-ctn').slideUp();
					}
				}
			});
		});
	};

	var init = function() {
		utils = Fw.component.models().utils;
		$('.com-authors__tab-content-author-btn').click(displayAuthor);

		if ($('.author.js-fetch-books').length > 0) {
			fetchBooks();
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
